/* nc-benefits — scroll-reveal, progressive fill-line, mobile comet finale.
   Ported from the source DCLogic. Self-contained, per-instance, no globals. */
(function () {
  'use strict';

  function init(root) {
    if (root.__ncBxReady) return;
    root.__ncBxReady = true;

    var ul = root.querySelector('[data-bx-ben]');
    if (!ul) return;
    var items = Array.prototype.slice.call(ul.querySelectorAll('.bx-benefit'));
    if (!items.length) return;
    var fill = root.querySelector('.bx-fillline');
    var comet = root.querySelector('.bx-comet');
    var inner = root.querySelector('.bx-inner');
    var cta = root.querySelector('.bx-cta');

    var revealed = 0;
    var scrolled = false;
    var launched = false;
    var raf = 0;
    var rafTo = 0;
    var timers = [];

    var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var mobileMQ = window.matchMedia ? window.matchMedia('(max-width: 860px)') : null;

    // Gate the hidden/reveal states; without JS the benefits stay visible.
    ul.classList.add('bx-reveal');

    function fillPct(count) {
      if (!count) return 0;
      var li = items[count - 1];
      var ic = li.querySelector('.bx-ic');
      var center = li.offsetTop + (ic ? ic.offsetTop + ic.offsetHeight / 2 : li.offsetHeight / 2);
      var total = ul.scrollHeight || 1;
      return Math.min(100, Math.round((center / total) * 1000) / 10);
    }

    function apply(count) {
      for (var i = 0; i < count; i++) items[i].classList.add('bx-in');
      var pct = fillPct(count);
      if (fill && pct > 0) {
        fill.style.height = pct + '%';
        fill.style.visibility = 'visible';
      }
    }

    function launchComet() {
      if (!ul || !inner || !cta || !comet) return;
      var irect = inner.getBoundingClientRect();
      var last = items[items.length - 1];
      var ic = last && last.querySelector('.bx-ic');
      var icr = (ic || last).getBoundingClientRect();
      var ulr = ul.getBoundingClientRect();
      var sx = ulr.left + 27 - irect.left;
      var sy = icr.top + icr.height / 2 - irect.top;
      var cr = cta.getBoundingClientRect();
      var tx = cr.left + cr.width / 2 - irect.left;
      var ty = cr.top + cr.height / 2 - irect.top;
      if (fill) fill.classList.add('bx-notip');
      comet.style.visibility = 'visible';
      comet.style.opacity = '1';
      comet.style.transform = 'translate(' + sx + 'px,' + sy + 'px)';
      timers.push(setTimeout(function () { comet.style.transform = 'translate(' + tx + 'px,' + ty + 'px)'; }, 60));
      timers.push(setTimeout(function () { cta.classList.add('bx-hit'); comet.style.opacity = '0'; }, 880));
      timers.push(setTimeout(function () { comet.style.visibility = 'hidden'; }, 1250));
    }

    function maybeLaunch() {
      if (launched) return;
      if (!mobileMQ || !mobileMQ.matches) return; // finale is mobile-only
      launched = true;
      if (reduceMQ && reduceMQ.matches) return;
      timers.push(setTimeout(launchComet, 950));
    }

    function check() {
      if (reduceMQ && reduceMQ.matches) {
        if (revealed < items.length) { revealed = items.length; apply(revealed); }
        return;
      }
      if (!scrolled) {
        var de = document.documentElement;
        var canScroll = (de.scrollHeight - (window.innerHeight || de.clientHeight || 0)) > 24;
        if (canScroll) return; // nothing reveals until the user actually scrolls
      }
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      var count = 0;
      for (var i = 0; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        if (r.top < vh * 0.88) count = i + 1; else break;
      }
      if (count > revealed) { revealed = count; apply(count); }
      if (count === items.length) maybeLaunch();
    }

    function schedule() {
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; check(); });
      // rAF can be throttled to never in a hidden iframe — guarantee the check runs.
      clearTimeout(rafTo);
      rafTo = setTimeout(function () {
        if (raf) { try { cancelAnimationFrame(raf); } catch (e) {} raf = 0; }
        check();
      }, 150);
    }

    var onScroll = function () { scrolled = true; check(); };
    var onResize = function () { schedule(); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    schedule();
    timers = [120, 400, 900, 1600].map(function (ms) { return setTimeout(schedule, ms); });

    // Tear down cleanly when the section is removed/reloaded in the theme editor.
    root.__ncBxTeardown = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      timers.forEach(clearTimeout);
      clearTimeout(rafTo);
      if (raf) { try { cancelAnimationFrame(raf); } catch (e) {} }
    };
  }

  function boot() {
    document.querySelectorAll('[data-nc-benefits]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-nc-benefits]') : null;
    if (el) init(el);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-nc-benefits]') : null;
    if (el && typeof el.__ncBxTeardown === 'function') el.__ncBxTeardown();
  });
})();
